export default {
    'create-unit-size': 'Create unit',
    'edit-unit-size': 'Edit unit',

    'unit-size-name': 'Unit name',
    'notes': 'Notes',

    save: 'Save',
    cancel: 'Cancel',
    
    'delete-the-unit-size': 'Delete unit',
    'are-you-sure-you-want-to-delete-the-unit-size': 'Do you want to delete this unit?',

    headers: {
        'unit-size': 'Unit',
        'notes': 'Notes',
        'actions': 'Actions',
    }
}